import React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';

export const SearchInput = ({
  value,
  onChange,
  isStudent = false,
  message = 'Search options...',
}) => {
  return (
    <Box
      sx={{
        p: 1,
        position: 'sticky',
        top: 0,
        bgcolor: 'background.paper',
        zIndex: 1,
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      <TextField
        size='small'
        placeholder={message}
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        onFocus={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search
                fontSize='small'
                sx={{ color: 'var(--clr-theme-purple)' }}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'var(--clr-theme-purple)',
            },
            '&:hover fieldset': {
              borderColor: 'var(--clr-theme-purple)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'var(--clr-theme-purple)',
            },
          },
        }}
      />
    </Box>
  );
};
